module.exports = __webpack_public_path__ + "static/media/logo_acb.2a8a0e36.svg";